/**
 * Zupee environment headers, mirroring the Android request interceptor and
 * `getZupeeEnvHeaders` in verticaltv-pwa (`src/utils/apiConfig.ts`).
 *
 * Both headers are omitted unless their env var is set, so a build that does not
 * define them behaves exactly as before. Set them in `.env.development.local`
 * (gitignored) to point a local dev build at your own CSE slice:
 *
 *   REACT_APP_ZUPEE_ENV=cse
 *   REACT_APP_STAGE_ENV_ID=first-last
 *
 * CRA inlines env vars at compile time, so the dev server must be restarted
 * after changing either value.
 */
export const getZupeeEnvHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = {};
  const zupeeEnv = (process.env.REACT_APP_ZUPEE_ENV || '').trim();
  const stageEnvId = (process.env.REACT_APP_STAGE_ENV_ID || '').trim();

  if (zupeeEnv) {
    headers['x-zupee-env'] = zupeeEnv;
  }
  if (stageEnvId) {
    headers['z-stage-env-id'] = stageEnvId;
  }

  return headers;
};
